import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MemberService } from '../../service/member.service';
import { CreateLocation } from '../../service/service-request';
import { VendorService } from '../../service/vendor.service';
import { VehicleService } from '../../service/vehicle.service';
import { StateViewModel } from 'src/app/service/state.model';
import { CreateEditVehicleInternalModel, CityViewModel, IVehicleResponseModel, IAirportCodeList } from "src/app/service/vehicle.model";
import { ToastrService } from 'ngx-toastr';
import { AddressType, Constant, DefaultGUID, EnabledCountryCodes, TransportationFileUploadType } from 'src/app/@shared/constants/Constant';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import {EMPTY, Subscription} from 'rxjs';
import { LocationService } from 'src/app/service/location.service';
import { FilesService } from 'src/app/service/files.service';
import { NOTIFICATION_WARNING_TIME } from 'src/app/shared/properties/application.properties';
import { BUDetailViewModel } from '../../service/vendorDetailView.model';
import { LegTransportTypeEnum } from '../../shared/enums/leg-transport-type.enum';
import { DEFAULT_DATE_FORMAT } from '../../shared/properties/date-time.properties';
import { convertTimezoneToUTC, convertUTCtoTimezone } from '../../shared/utils/date-converter';
import * as moment from 'moment';
import {catchError} from 'rxjs/operators';

declare var $: any;
@Component({
    selector: 'app-add-edit-vehicle',
    templateUrl: './add-edit-vehicle.component.html',
    styleUrls: ['./add-edit-vehicle.component.css']
})
export class AddEditVehicleComponent implements OnChanges, OnInit {
    @Input() headerName: string;
    @Input() serviceType: string;
    @Input() isInternal: string;
    @Input() vehicleDetail: IVehicleResponseModel;
    @Input() vehicleId: string;
    @Input() vendorId: string;
    @Input() isEdit: boolean;
    @Input() selectedVendorDetails?: BUDetailViewModel;
    @Input() isVinNumberFieldVisible = false;
    @Output() vehicelIdEmit = new EventEmitter();
    @Output() getVehicleDetail = new EventEmitter();
    @Output() fetchVehicleDetail = new EventEmitter();
    @Output() closeAddEditVehiclePopup = new EventEmitter();
    @Output() fileUpdateDetails = new EventEmitter();
    @ViewChild('registrationFileInput') registrationFileInput: ElementRef;
    @ViewChild('insuranceFileInput') insuranceFileInput: ElementRef;
    public user: ILoggedInUserViewModel
    private _subscriptions: Subscription = new Subscription();
    public myId: any;
    public addressId: any;
    public countryList: any;
    public addressName: any;
    public uploadPicture: any;
    public insuranceFile: any;
    public registrationFile: any;
    public selectedInsuranceFiles = [];
    public selectedRegistrationFiles = [];
    public registrationExpirationTime: any = "";
    public registrationExpirationDatepicker = '';
    public insuranceExpirationTime: any = "";
  insuranceExpirationTimeDatepicker = '';
    public filesForUpload: any[] = [];
    public transportFile: any;
    public isShowAddCity = false;
    public display: boolean = false;
    public isCityButtonShow = false;
    public searchedAddr: string;
    public autoCompleteAddrInput;
    public AddressType: string[] = AddressType;
    public stateId: any;
    public cityList: any;
    public stateList: any;
    public loader: boolean = false;
    public airportCodeList: IAirportCodeList[] = [];
    public airport: string;
    public isShowAddAirportCode = false;
    protected readonly DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;

    constructor(
        public memberService: MemberService, private _vendorService: VendorService, private _locationService: LocationService,
        private vehicleService: VehicleService, private _toast: ToastrService, private _cdr: ChangeDetectorRef, private _fileService: FilesService,
    ) { }

    mapOriginConfig = {
        displayKey: "addressName",
        search: true,
        placeholder: 'Select Origin',
    }
    public Location: CreateLocation = {
        customerId: '',
        addressName: '',
        countryId: '',
        stateId: '',
        cityId: '',
        streetAddress: '',
        zipcode: '',
        latitude: '',
        longitude: '',
        addressType: '',
        isGlobal: true,
        businessUnitId: null,
        LocationAddressType: null,
        airportCode: null
    }
    public vehicle: CreateEditVehicleInternalModel = {
      vendorId: DefaultGUID,
      vehicleType: '',
      vehicleName: '',
      vehicleCategory: '',
      isCode3: false,
      vehicleNumber: '',
      description: '',
      filePath: '',
      model: '',
      companyName: '',
      year: '',
      addressId: null,
      serviceOffered: '',
      registrationExpirationTime: new Date,
      insuranceExpirationTime: new Date,
      aircraftCategoryId: '',
      vinNumber: ''
    };
    public city: CityViewModel = {
        cityId: DefaultGUID,
        id: DefaultGUID,
        cityName: "",
        cityCode: "",
        stateId: DefaultGUID
    }

    ngOnInit() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.getAircraftCategory();
        this.getLocation();
        this.getAllAirportCodeList();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.isEdit || this.isEdit == false) {
            this.clearVehicleData();
            if (this.vehicleDetail) {
                this.vehicle = {
                    addressId: (this.vehicleDetail.location != null &&
                        this.vehicleDetail.location.addressId != DefaultGUID) ?
                        this.vehicleDetail.location.addressId : null,

                    aircraftCategoryId: this.vehicleDetail.aircraftCategoryId,
                    companyName: this.vehicleDetail.make,
                    description: this.vehicleDetail.description,
                    filePath: this.vehicleDetail.profilePicture != null ? this.vehicleDetail.profilePicture.displayName : "",
                    isCode3: this.vehicleDetail.isCode3,
                    model: this.vehicleDetail.model,
                    registrationExpirationTime: this.checkNullUndefined(this.vehicleDetail.registrationExpirationTime) ?
                        this.vehicleDetail.registrationExpirationTime : null,
                    insuranceExpirationTime: this.checkNullUndefined(this.vehicleDetail.insuranceExpirationTime) ?
                        this.vehicleDetail.insuranceExpirationTime : null,
                    serviceOffered: this.vehicleDetail.serviceOffered,
                    vehicleCategory: this.vehicleDetail.vehicleCategory,
                    vehicleName: this.vehicleDetail.vehicleName,
                    vehicleNumber: this.vehicleDetail.vehicleName,
                    vehicleType: this.vehicleDetail.vehicleType,
                    vendorId: this.vendorId,
                    year: this.vehicleDetail.year,
                    vinNumber: this.vehicleDetail.vinNumber
                }
                this.insuranceFile = this.vehicleDetail.insuranceFile;
                this.registrationFile = this.vehicleDetail.registrationFile;

                this.vehicle.vehicleName = this.vehicleDetail.vehicleName;
                this.vehicle.vehicleCategory = this.vehicleDetail.vehicleCategory;
                this.vehicle.model = this.vehicleDetail.model;
                this.vehicle.vehicleNumber = this.vehicleDetail.vehicleNumber;
                if (this.vehicleDetail.location != null && this.vehicleDetail.location.addressId != DefaultGUID) {
                    this.addressName = this.vehicleDetail.location.addressName;
                    this.vehicle.addressId = this.vehicleDetail.location.addressId;
                }
                else {
                    this.addressName = null;
                    this.vehicle.addressId = DefaultGUID;
                }
                this.vehicle.serviceOffered = this.vehicleDetail.serviceOffered;
                this.vehicle.isCode3 = this.vehicleDetail.isCode3;
                this.vehicle.vehicleType = this.vehicleDetail.vehicleType;
                this.vehicle.year = this.vehicleDetail.year;
                this.vehicle.vendorId = this.vendorId;
                this.vehicle.description = this.vehicleDetail.description;
                this.vehicle.registrationExpirationTime = this.checkNullUndefined(this.vehicleDetail.registrationExpirationTime) ?
                    this.vehicleDetail.registrationExpirationTime : null;
                this.registrationExpirationTime = this.vehicle.registrationExpirationTime;
                this.vehicle.insuranceExpirationTime = this.checkNullUndefined(this.vehicleDetail.insuranceExpirationTime) ?
                    this.vehicleDetail.insuranceExpirationTime : null;
                this.insuranceExpirationTime = this.vehicle.insuranceExpirationTime;
                if (this.vehicleDetail["profilePicture"] == null) {
                    this.vehicleImag = false;
                }
                else {
                    this.vehicleImag = true;
                }
                if (this.vehicleDetail["profilePicture"]) {
                    this.vehicle.filePath = this.vehicleDetail["profilePicture"].displayName;
                }
                else if (this.vehicleDetail["filePath"]) {
                    this.vehicle.filePath = this.vehicleDetail["filePath"]
                }
                if (this.vehicleDetail["make"]) {
                    this.vehicle.companyName = this.vehicleDetail["make"];
                }
                else {
                    this.vehicle.companyName = this.vehicleDetail["companyName"];
                }
                this.vehicle.aircraftCategoryId = this.vehicleDetail.aircraftCategoryId;

              const localExpirationTime = convertUTCtoTimezone(this.vehicleDetail.registrationExpirationTime?.toString(), Constant.selectedOffsetTime);
              const localInsuranceExpirationTime = convertUTCtoTimezone(this.vehicleDetail.insuranceExpirationTime?.toString(), Constant.selectedOffsetTime);

              this.insuranceExpirationTimeDatepicker = moment(localInsuranceExpirationTime).format('MM-DD-YYYY');
              this.registrationExpirationDatepicker = moment(localExpirationTime).format('MM-DD-YYYY');
            }
        }
        if (this.headerName == "Add") {
            this.clearVehicleData();
            this.clearLocation();
        }
    }

    checkNullUndefined(data: any): boolean {
        if (data) return true;
        else return false;
    }

    initializeDatepicker() {
      $('#insuranceExpirationDate').datetimepicker({
        timepicker: false,
        startDate: new Date(),
        format: 'm-d-Y',
        minDate: 0,
        formatDate: 'd/m/Y',
        step: 5,
      });
    }

  initializeRegistrationExpirationDatepicker(): void {
    $('#registrationExpirationDate').datetimepicker({
      timepicker: false,
      startDate: this.registrationExpirationTime ? this.registrationExpirationTime : new Date(),
      format: 'm-d-Y',
      minDate: 0,
      formatDate: 'd/m/Y',
      step: 5,
      onChangeDateTime: (date: Date): void => {
        this.registrationExpirationTime = date;
        this.registrationExpirationDatepicker = $('#registrationExpirationDate').val();
      },
    });
  }

  initializeInsuranceExpirationDateDatepicker(): void {
    $('#insuranceExpirationDate').datetimepicker({
      timepicker: false,
      startDate: this.insuranceExpirationTime ? this.insuranceExpirationTime : new Date(),
      format: 'm-d-Y',
      minDate: 0,
      formatDate: 'd/m/Y',
      step: 5,
      onChangeDateTime: (date: Date): void => {
        this.insuranceExpirationTime = date;
        this.insuranceExpirationTimeDatepicker = $('#insuranceExpirationDate').val();
      },
    });
  }

    utcToLocalConvert(utcDate) {
        var newDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000);
        var offset = utcDate.getTimezoneOffset() / 60;
        var hours = utcDate.getHours();
        newDate.setHours(hours - offset);
        return newDate;
    }

    getCityByState(event, flag?) {
        this.isCityButtonShow = true;
        this.stateId = event;
        this._vendorService.getCityByState(this.stateId).subscribe(response => {
            this.cityList = response;
            if (this.cityList.length > 0 && flag != undefined) {
                this.Location.cityId = this.cityList ? this.cityList.find(x => x.cityId == flag).cityId : null;
            }
        })
    }
    public stateListForMember: StateViewModel[] = []
    getStateList() {
        this._vendorService.getStateList().subscribe(response => {
            this.stateListForMember = response;
            this.getCountryList();

        });
    }
    getCountryList() {
        this.memberService.getCountryList().subscribe(response => {
            this.countryList = response;
        });
    }
    resetForm(loginForm: any) {
        loginForm.resetForm();
    }

    public getAllAirportCodeList() {
        if (this._locationService.airportCodeList$.value.length > 0) {
            this.airportCodeList = this._locationService.airportCodeList$.value;
        }
        else {
            this._subscriptions.add(
                this._locationService.getAllAirportCodeList().subscribe(
                    (response) => {
                        this.airportCodeList = response;
                    }
                )
            );
        }
    }

    public addAirportCode() {
        this.airportCodeList.push({
            addressId: DefaultGUID,
            airportCode: this.airport.toUpperCase(),
            airportName: null
        });
        this.Location.airportCode = this.airport.toUpperCase();
        this.airport = '';
    }

    public locationList: any;
    getLocation() {
        if (this.vendorId) {
            this.Location['customerId'] = this.vendorId;
        }
        this.vehicleService.getLocation(this.Location['customerId']).subscribe(response => {
            this.locationList = response;
            this.getStateList();

        });
    }
    public aircraftCategoryList: any;
    getAircraftCategory() {
        this.vehicleService.getAirCategory().subscribe(response => {
            this.aircraftCategoryList = response;
            this.getVehicleCategory();
        })
    }
    public vehicleCategory: any;
    getVehicleCategory() {
        this.vehicleService.getVehicleCategory().subscribe(response => {
            this.vehicleCategory = response;
        })
    }
    addLocation(locationData: CreateLocation, formData) {
        if (formData.form.valid) {
            locationData.businessUnitId = this.user.businessUnitId;
            let copyAddress = [...this.locationList];
            copyAddress.forEach(x => x.address = x.streetAddress + ", " + x.cityName + ", " + x.state + ", " + x.zipCode);
            this.clearCityData();
            if (this.vendorId) {
                locationData.customerId = this.vendorId;
            }
            let country = this.countryList.find(x => x.countryName == "USA");
            locationData.countryId = country.countryId;
            let cityName = this.cityList.find((x) => x.cityId == this.Location.cityId);
            let stateName = this.stateListForMember.find((x) => x.stateId == this.Location.stateId);
            let myCountry = this.stateListForMember.find((x) => x.stateId == this.Location.stateId);
            if (myCountry != null) {
                country = this.countryList.find((x) => x.countryId == myCountry.countryId);
                locationData.countryId = country.countryId;
            }
            let countryName = country.countryName != null ? country.countryName : "USA";
            let address = `${this.Location.addressName}, ${this.Location.streetAddress}, ${cityName.cityName}, ${stateName.stateName} ${countryName} ${this.Location.zipcode}`;
            let selectedLoc = copyAddress.find(x => x.address.includes(`${this.Location.streetAddress}, ${cityName.cityName}, ${stateName.stateName}, ${this.Location.zipcode}`));

            if (this.Location.addressName == '' || this.Location.stateId.length == 0 || this.Location.cityId.length == 0 || this.Location.streetAddress == '' || this.Location.zipcode == '') {
                this._toast.error("Please fill all the required fields!", "ERROR", {
                    timeOut: 2000,
                    positionClass: 'toast-top-center'
                });
            }
            else {
                this.loader = true;
                locationData.addressType = "VehicleAddress";
                if (selectedLoc == undefined) {
                    var geocoder = new google.maps.Geocoder();
                    let This = this;
                    geocoder.geocode(
                        {
                            address: address,
                        },
                        function (results, status) {
                            if (status == "OK") {
                                let longitude = results[0].geometry.location.lng();
                                let latitude = results[0].geometry.location.lat();
                                if (longitude && latitude) {
                                    locationData.latitude = latitude.toString();
                                    locationData.longitude = longitude.toString();
                                    This.createLocation(locationData);
                                    This.resetLocationForm(formData);
                                }
                            }
                            else {
                                This.loader = false;
                                This.clearLocation();
                                This.resetLocationForm(formData);
                                This._toast.error(
                                    "Location not found! Please check your address.",
                                    "Error",
                                    {
                                        timeOut: 6000,
                                        positionClass: "toast-top-center",
                                    }
                                );
                            }
                        });
                }
                else {
                    this.setLocation(selectedLoc);
                    this.resetLocationForm(formData);
                    this.hideLocation();
                }
            }
        }
        else {
            this.showLocation();
        }
    }

    private hideLocation() {
        $("#addLocation").modal("hide");
    }
    private showLocation() {
        $("#addLocation").modal("show");
    }

    resetLocationForm(addLocationForm: any) {
        addLocationForm.resetForm();
    }

    createLocation(locationData: CreateLocation) {
        this.memberService.addLocation(locationData).subscribe(
            (response) => {
                this.loader = false;
                this.clearLocation();
                this.getLocation();
                this.setLocation(response)
                this._toast.success('Location Added Successfully!', 'Success!', {
                    timeOut: 6000,
                    positionClass: 'toast-top-center'
                });
                this.hideLocation();
            },
            (err) => {
                if (err.error.message == 'Address already exist') {
                    this._toast.warning(err?.error?.message, 'Warning', { timeOut: NOTIFICATION_WARNING_TIME, positionClass: 'toast-top-center', });
                }
                else {
                    this._toast.warning('Something went wrong! Please try again', 'Warning', { timeOut: NOTIFICATION_WARNING_TIME, positionClass: 'toast-top-center', });
                }
                this.loader = false;
            }
        );
    }

    setLocation(location) {
        this.addressName = location.location
    }

    addVehicleDetails(type, event: NgForm): void {
      this.loader = true;

      if (event.form.valid) {
            this.vehicle.vendorId = this.vendorId;
            this.vehicle.filePath = this.transportFile;
            this.vehicle.vehicleType = type;
            this.vehicle.serviceOffered = type;
            let multipleFilesForUpload = [];

            if (type != "Air") {
              this.vehicle.registrationExpirationTime = this.checkNullUndefined(this.registrationExpirationTime) ?
                this.utcToLocalConvert(new Date(this.registrationExpirationTime)) : null;
              this.insuranceExpirationTime = $("#insuranceExpirationDate").val();
              this.vehicle.insuranceExpirationTime = this.checkNullUndefined(this.insuranceExpirationTime) ?
                this.utcToLocalConvert(new Date(this.insuranceExpirationTime)) : null;

              this.vehicle.vehicleCategory = "Vehicle";
              this.vehicle.addressId = this.vehicle.addressId ? this.vehicle.addressId : null;

              this.vehicleService.createVehicle(this.vehicle).subscribe((response) => {
                this.loader = false;
                this._toast.success("Vehicle Added Successfully", "Record Saved", {
                  timeOut: 2000,
                  positionClass: 'toast-top-center'
                });
                this.getVehicleDetail.emit("Vehicle");
                this.clearVehicleData();
                this.fetchVehicleDetail.emit(type);
                if (!this.vehicleImag) {
                  this.attachDocument(response, 'uploadProfilePicture', type);
                }
                if (this.selectedInsuranceFiles.length > 0) {
                  multipleFilesForUpload.push(this.selectedInsuranceFiles[0]);
                  this.multipleFileAttach(multipleFilesForUpload, TransportationFileUploadType.Insurance, response);
                  multipleFilesForUpload = [];
                }
                if (this.selectedRegistrationFiles.length > 0) {
                  multipleFilesForUpload.push(this.selectedRegistrationFiles[0]);
                  this.multipleFileAttach(multipleFilesForUpload, TransportationFileUploadType.Registration, response);
                }
                if(this.vehicleImag && this.selectedInsuranceFiles.length == 0 && this.selectedRegistrationFiles.length == 0) {
                  this.vehicelIdEmit.emit(response);
                }
                event.resetForm();
              });
              $("#addEditVehicle").modal('hide');

            } else {
                this.vehicle.vehicleCategory = "Aircraft";
                this.vehicle.registrationExpirationTime = this.checkNullUndefined(this.registrationExpirationTime) ?
                    this.utcToLocalConvert(new Date(this.registrationExpirationTime)) : null;
                this.insuranceExpirationTime = null;

              this.vehicleService.createVehicle(this.vehicle).subscribe((response) => {
                    this.loader = false;
                    this._toast.success("Record Added Successfully", "Record Saved", {
                        timeOut: 2000,
                        positionClass: 'toast-top-center'
                    });
                    this.clearVehicleData();
                    this.getVehicleDetail.emit("Aircraft");
                    this.fetchVehicleDetail.emit(type);
                    if (!this.vehicleImag) {
                        this.attachDocument(response, 'uploadProfilePicture', type);
                    }
                    if (this.selectedRegistrationFiles.length > 0) {
                        this.getVehicleDetail.emit("Aircraft");
                        this.fetchVehicleDetail.emit(type);
                        multipleFilesForUpload.push(this.selectedRegistrationFiles[0]);
                        this.multipleFileAttach(multipleFilesForUpload, TransportationFileUploadType.SafetyCredentials, response);
                    }
                    if(this.vehicleImag && this.selectedRegistrationFiles.length == 0) {
                        this.vehicelIdEmit.emit(response);
                    }
                    event.resetForm();
                });

                $("#addEditVehicle").modal('hide');

            }
        }

        else this.loader = false;
    }

    editVehicleDetails(type: string, event: NgForm): void {
      if (event.form.invalid) return;
      let multipleFilesForUpload = [];
      if (type !== 'Air') {
        this.loader = true;
        this.convertExpirationDates();
        this.vehicle.vehicleCategory = 'Vehicle';
        this.vehicleService.updateVehicleDetail(this.vehicle, this.vehicleId)
          .pipe(
            catchError(() => {
              this._toast.error('Error updating vehicle details', 'Error', {
                timeOut: 2000,
                positionClass: 'toast-top-center'
              });
              return EMPTY;
            })
          )
          .subscribe((response) => {
            if (response) {
              this._toast.success("Record Updated Successfully", "Record Updated", {
                timeOut: 2000,
                positionClass: 'toast-top-center'
              });
              this.getVehicleDetail.emit("Vehicle");
              this.getVehicleDetail.emit("Aircraft");
              this.fetchVehicleDetail.emit(type);

              if (this.selectedInsuranceFiles.length > 0) {
                multipleFilesForUpload.push(this.selectedInsuranceFiles[0]);
                this.multipleFileAttach(multipleFilesForUpload, TransportationFileUploadType.Insurance, this.vehicleId, type);
                multipleFilesForUpload = [];
              }

              if (this.selectedRegistrationFiles.length > 0) {
                multipleFilesForUpload.push(this.selectedRegistrationFiles[0]);
                this.multipleFileAttach(multipleFilesForUpload, TransportationFileUploadType.Registration, this.vehicleId, type);
              }
              if (!this.vehicleImag) {
                this.attachDocument(this.vehicleId, 'uploadProfilePicture', type, true);
              }
              this.loader = false;
              event.resetForm();
              $("#addEditVehicle").modal('hide');
            }
        });
      } else {
        this.loader = true;
        this.vehicle.vehicleCategory = 'Aircraft';
        this.convertExpirationDates();
        this.vehicleService.updateVehicleDetail(this.vehicle, this.vehicleId)
          .pipe(
            catchError(() => {
              this._toast.error('Failed to update record. Please try again.', 'Error', {
                timeOut: 2000,
                positionClass: 'toast-top-center'
              });
              return EMPTY;
            })
          )
          .subscribe(() => {
            if (this.selectedRegistrationFiles.length > 0) {
              multipleFilesForUpload.push(this.selectedRegistrationFiles[0]);
              this.multipleFileAttach(multipleFilesForUpload, TransportationFileUploadType.SafetyCredentials, this.vehicleId, type);
            }
            if (!this.vehicleImag) {
              this.attachDocument(this.vehicleId, 'uploadProfilePicture', type, true)
            } else {
              this.getVehicleDetail.emit('Aircraft');
              this.fetchVehicleDetail.emit(type);
              this.loader = false;
              event.resetForm();
            }
            this._toast.success('Record Updated Successfully', 'Record Updated', {
              timeOut: 2000,
              positionClass: 'toast-top-center'
            });
            $('#addEditVehicle').modal('hide');
          });
      }
    }

  selectAddress(event): void {
    this.vehicle.addressId = event.value.addressId ? event.value.addressId : null;
    }

    closeLocation(id) {
        $("#" + id).modal('hide');
    }

    clearLocation() {
        this.Location = {
            'customerId': DefaultGUID,
            'addressName': '',
            'countryId': '',
            'stateId': '',
            'cityId': '',
            'streetAddress': '',
            'zipcode': '',
            'latitude': '',
            'longitude': '',
            'addressType': '',
            'isGlobal': true,
            'businessUnitId': null,
            'LocationAddressType': null,
            'airportCode': null
        };
    }

    clearFilesDetails() {
        const registrationInput = this.registrationFileInput?.nativeElement as HTMLInputElement;
        const insuranceInput = this.insuranceFileInput?.nativeElement as HTMLInputElement;
        if (registrationInput) {
            registrationInput.value = '';
        }
        if (insuranceInput) {
            insuranceInput.value = '';
        }
    }

    clearVehicleData() {
        this.addressName = "";
        this.registrationExpirationTime = "";
        this.insuranceExpirationTime = "";
        this.insuranceExpirationTimeDatepicker = '';
        this.registrationExpirationDatepicker = '';

        this.vehicle = {
          vendorId: DefaultGUID,
          vehicleType: '',
          vehicleName: '',
          vehicleCategory: '',
          isCode3: false,
          vehicleNumber: '',
          description: '',
          filePath: '',
          model: '',
          companyName: '',
          year: '',
          addressId: null,
          serviceOffered: '',
          registrationExpirationTime: new Date,
          insuranceExpirationTime: new Date,
          aircraftCategoryId: '',
          vinNumber: ''
        };
        this.clearLocation();
        this.clearFilesDetails();
    }

    fileUpload = [];
    public editMemberProfile: any;
    public vehicleImag: boolean = true;
    bindFileName(name) {
        this.vehicleImag = false;
        this.fileUpload = [];
        this.fileUpload.push(name.split("\\")[2]);
    }
    public fileDataValue: any;
    attachDocument(memberID, id, type, flag?) {
        let accessToken = localStorage.getItem("AccessToken");
        let path = id == 'uploadProfilePicture' ? 'uploadFile' : 'editProfile';
        let category = type == 'Ground' ? 'Vehicle' : "Aircraft";
        if (flag != undefined && flag == true) path = 'editProfile';
        this.fileDataValue = new FormData();
        var fileUpload = $("#" + id).get(0);
        var files = fileUpload.files;
        this.fileDataValue.append(this.fileUpload[0], files[0]);
        path == 'uploadFile' ?
            this.uploadFile('profile', category, memberID, this.fileDataValue, type) :
            this.editProfile('profile', category, memberID, this.fileDataValue, type);
    }

    uploadFile(fileType: string, entityTableName: string, entityTableValue: string, fileInfo: FormData, type: string) {
        this._fileService.uploadFile(fileType, entityTableName, entityTableValue, fileInfo).subscribe(
            (response) => {
                this.loader = false;
                if (type == 'Air') {
                    this.fetchVehicleDetail.emit(type);
                    this.getVehicleDetail.emit("Aircraft");
                }
                else if (type == 'Ground') {
                    this.fetchVehicleDetail.emit(type);
                    this.getVehicleDetail.emit("Vehicle");
                }
                this.vehicelIdEmit.emit(entityTableValue);
            },
            (error) => {
                console.log(error);
                this.loader = false;
            }
        );
    }

    editProfile(fileType: string, entityTableName: string, entityTableValue: string, fileInfo: FormData, type: string) {
        this._fileService.editProfilePictureAsync(fileType, entityTableName, entityTableValue, fileInfo).subscribe(
            (response) => {
                this.loader = false;
                if (type == 'Air') {
                    this.fetchVehicleDetail.emit(type);
                    this.getVehicleDetail.emit("Aircraft");
                }
                else if (type == 'Ground') {
                    this.fetchVehicleDetail.emit(type);
                    this.getVehicleDetail.emit("Vehicle");
                }
                this.vehicelIdEmit.emit(entityTableValue);
            },
            (error) => {
                console.log(error);
                this.loader = false;
            }
        );
    }
    addCity() {
        if (this.city.cityName != "") {
            this.city.stateId = this.Location.stateId;

            if (/\s/.test(this.city.cityName)) {
                var city = this.city.cityName.split(' ');
                var one = city[0].substring(0, 1);
                var two = city[1].substring(0, 1);
                this.city.cityCode = one + two;
            }
            else {
                this.city.cityCode = this.city.cityName.substring(0, 2);
            }
            this.loader = true;
            this.memberService.addCity(this.city).subscribe(
                (response) => {
                    this.loader = false;
                    this.isShowAddCity = false;
                    this.getCityByState(this.stateId, response);
                    this.clearCityData();
                },
                (err) => {
                    console.log(err);
                    this._toast.warning(
                        "Something went wrong! Please try again",
                        "Warning",
                        {
                            timeOut: 6000,
                            positionClass: "toast-top-center",
                        }
                    );
                    this.loader = false;
                }
            );
        }
        else {
            this.isShowAddCity = false;
            this.clearCityData();
        }
    }
    clearCityData() {
        this.city = {
            'cityId': DefaultGUID,
            'id': DefaultGUID,
            'cityName': '',
            'cityCode': '',
            'stateId': DefaultGUID
        }
    }
    descriptionSize(data) {
        if (this.vehicle.description == "" || this.vehicle.description == null) {
            this.display = false;
        }
        else if (data.length > 255) {
            this.display = true;
        }
        else
            this.display = false;
    }

    emitPopupCloseEvent() {
        this.closeAddEditVehiclePopup.emit();
    }

    setInsuranceFile(uploadedFile) {
        const tempFileList = $("#" + uploadedFile)[0].files;
        const tempFileListArray = Array.from(tempFileList);
        tempFileListArray.forEach((file) => {
            file["fileId"] = 0;
            file["fileType"] = file["type"].split("/")[1];
            file["displayName"] = file["name"];
            file["extension"] = file["type"].split("/")[1];
            file["fileName"] = file["name"].split(".")[0];
            file["IsEditable"] = false;
            this.selectedInsuranceFiles.push(file);
        });
    }

    setRegistrationFile(uploadedFile) {
        this.selectedRegistrationFiles = [];
        const tempFileList = $("#" + uploadedFile)[0].files;
        const tempFileListArray = Array.from(tempFileList);
        tempFileListArray.forEach((file) => {
            file["fileId"] = 0;
            file["fileType"] = file["type"].split("/")[1];
            file["displayName"] = file["name"];
            file["extension"] = file["type"].split("/")[1];
            file["fileName"] = file["name"].split(".")[0];
            file["IsEditable"] = false;
            this.selectedRegistrationFiles.push(file);
        });
    }


    multipleFileAttach(fileList, entityTableName, entityTableValue, Type?) {
        const accessToken = localStorage.getItem("AccessToken");
        // this.loader = true;
        if (fileList.length != 0) {
            let path = "";
            let multipleFileUpload = new FormData();
            fileList.forEach((item) => {
                path = path.concat(item.fileType + ",");
                multipleFileUpload.append(item.name, item);
            });
            path = path.replace(/,(?=\s*$)/, "");


            this._fileService.uploadFile(path, entityTableName, entityTableValue, multipleFileUpload).subscribe(
                (response) => {
                    this.selectedInsuranceFiles = [];
                    this.selectedRegistrationFiles = [];
                    this.vehicleService.refreshVehicleList$.next(true);
                    const outputObject = {
                        displayName: fileList[0].displayName,
                        fileType: entityTableName,
                        vehicleID: entityTableValue
                    }
                    this.fileUpdateDetails.emit(outputObject);
                    if (Type === "Air") {
                        this.getVehicleDetail.emit("Aircraft");
                    }
                    else if (Type === "Ground") {
                        this.getVehicleDetail.emit("Vehicle");
                    }
                    this.fetchVehicleDetail.emit(Type);
                },
                (error) => {
                    // this.loader = false;
                    console.log(error);
                }
            );
        }
    }

    autoSearchAddress() {
        var autocomplete: any;
        var options = {
            componentRestrictions: { country: EnabledCountryCodes },
            fields: ["address_component", "adr_address", "business_status", "formatted_address"]
        } as google.maps.places.AutocompleteOptions;
        this.autoCompleteAddrInput = document.getElementById('autocompleteAddress') as HTMLInputElement;
        autocomplete = new google.maps.places.Autocomplete(this.autoCompleteAddrInput, options);
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            var place = autocomplete.getPlace();
            this.Location.addressName = $('#autocompleteAddress').val().split(',')[0];
            if (place != null && place["adr_address"] != null) {
                this.autoSelectAddress(place["adr_address"], place["address_components"])
            }
        });
    }

    autoSelectAddress(str, formatted_address: any[]) {
        this.clearLocationAddressData();
        var htmlAddr = str;
        var parser = new DOMParser();
        var parsedData = parser.parseFromString(htmlAddr, 'text/html');
        var arr = parsedData.getElementsByTagName("span");
        this.Location.streetAddress = this.returnStreetAddress(parsedData);
        this.Location.zipcode = this.returnZipCode(parsedData);
        const stateCode = this.returnStateCode(parsedData);
        var currState = this.stateListForMember.find((x) => x.stateCode == stateCode);
        if (currState != null || currState != undefined) {
            this.Location.stateId = currState.stateId;
            this._vendorService.getCityByState(currState.stateId).subscribe((response) => {
                this.cityList = response;
                const cityName = parsedData.getElementsByClassName("locality").length > 0 ? parsedData.getElementsByClassName("locality")[0].innerHTML : null;
                var currCity = this.cityList.find(
                    (x) => x.cityName == cityName
                );
                if (currCity == null || currCity == undefined) {
                    this.city.cityName = cityName;
                    this.addCity();
                } else {
                    this.Location.cityId = currCity.cityId;
                    this.Location.stateId = currState.stateId;
                }
                this._cdr.detectChanges();
            });
        }
        else {
            for (let i = 0; i < formatted_address.length; i++) {
                if (formatted_address[i]["types"][0] == "administrative_area_level_1" || formatted_address[i]["types"][0] == "locality") {
                    let city = this.cityList ? this.cityList.find((x) => x.cityName == formatted_address[i]["long_name"]) : null;
                    if (city != null || city != undefined) {
                        this.Location.cityId = city.cityId;
                    }
                    else {
                        this.city.cityName = formatted_address[i]["long_name"];
                        let state = this.stateListForMember.find((x) => x.stateName == formatted_address[i]["long_name"]);
                        if (state != null || state != undefined) {
                            this.Location.stateId = state.stateId;
                        }
                    }
                }

                if (formatted_address[i]["types"][0] == "country") {
                    let country = this.countryList.find((x) => x.countryName == formatted_address[i]["long_name"])
                    if (country != null || country != undefined) this.Location.countryId = country.countryId;
                    if (formatted_address[i]["long_name"] == "Puerto Rico" || formatted_address[i]["long_name"] == "United States") {
                        let state = this.stateListForMember.find((x) => x.stateName == formatted_address[i]["long_name"]);
                        if (state != null || state != undefined) {
                            this.Location.stateId = state.stateId;
                        }
                    }
                }
                if (formatted_address[i]["types"][0] == "postal_code") {
                    this.Location.zipcode = formatted_address[i]["long_name"];
                }
            }
        }
    }

    private clearLocationAddressData(): void {
        this.Location.streetAddress = "";
        this.Location.stateId = "";
        this.Location.cityId = "";
        this.Location.zipcode = "";
    }

    private returnStreetAddress(parsedData: Document): string {
        const streetAddr: string = parsedData.getElementsByClassName("street-address").length > 0 ? parsedData.getElementsByClassName("street-address")[0].innerHTML : "";
        return streetAddr;
    }

    private returnZipCode(parsedData: Document): string {
        const zipCode: string = parsedData.getElementsByClassName("postal-code").length > 0 ? parsedData.getElementsByClassName("postal-code")[0].innerHTML.substring(0, 5) : "";
        if (zipCode.length != 0 && zipCode.includes(" ")) return zipCode.substring(0, 3);
        else return zipCode;
    }

    private returnStateCode(parsedData: Document): string {
        const stateCode = parsedData.getElementsByClassName("region").length > 0 ? parsedData.getElementsByClassName("region")[0].innerHTML : null;
        return stateCode;
    }

    protected get vehicleTitle(): string {
      return this.serviceType === LegTransportTypeEnum.Ground ? 'Vehicle Name' : 'Aircraft Name';
    }

    protected get vehicleNumberTitle(): string {
      return this.serviceType === LegTransportTypeEnum.Ground ? 'Plate Number' : 'Tail#';
    }

    protected get registrationExpirationTitle(): string {
      return this.serviceType === LegTransportTypeEnum.Ground ? 'Registration Expiration Date' : 'Safety Credentials Expiration Date';
    }

    private convertExpirationDates(): void {
      if (this.registrationExpirationDatepicker) {
        this.vehicle.registrationExpirationTime = convertTimezoneToUTC(this.registrationExpirationDatepicker, Constant.selectedOffsetTime)
      }

      if (this.insuranceExpirationTimeDatepicker) {
        this.vehicle.insuranceExpirationTime = convertTimezoneToUTC(this.insuranceExpirationTimeDatepicker, Constant.selectedOffsetTime);
      }
    }
}
